// extracted by mini-css-extract-plugin
module.exports = {"text":"SoldOutModal_text__zi7wf","button":"SoldOutModal_button__VTlzh"};